export const asosGlobalNamespace = "asos";
export const siteChromeGlobalNamespace = "siteChrome";
export const sdkGlobalNamespace = "sdk";
export const manifestWindowKey = "_versionManifest";
export const featureManifestWindowKey = "featureManifest";
export const siteChromeInitialStore = "_initialStore";
export const siteChromeTokenValues = "_tokenValues";
export const RECENT_SEARCHES_KEY = "_asosRecentSearches";
export const siteChromeClientConfig = "_config";
export const clientEnvPrefix = "CLIENT_";
